import {
  TradingAccount,
  WalletDirectionTypeId,
  WalletTransaction,
} from 'api/Transaction/Types/Transaction'
import { WalletType } from 'api/Wallet/Types/Wallet'

export function getCreditCreditOrFirstOneWallet(
  walletTransactions: WalletTransaction[],
  type?: 'Credit' | 'Debit'
): WalletTransaction | undefined {
  if (type === 'Credit') {
    return (walletTransactions || []).find(
      (w) => w.directionType.id === WalletDirectionTypeId.CREDIT
    )
  }

  if (type === 'Debit') {
    return (walletTransactions || []).find(
      (w) => w.directionType.id === WalletDirectionTypeId.DEBIT
    )
  }

  return walletTransactions[0]
}

export function getClientWalletNonPaymentAgentType(
  walletTransactions: WalletTransaction[],
  type?: 'Credit' | 'Debit'
): WalletTransaction | undefined {
  if (type === 'Credit') {
    return (walletTransactions || []).find(
      (w) =>
        w.directionType.id === WalletDirectionTypeId.CREDIT &&
        w.wallet.walletType.id !== WalletType.PAYMENT_AGENT
    )
  }

  if (type === 'Debit') {
    return (walletTransactions || []).find(
      (w) =>
        w.directionType.id === WalletDirectionTypeId.DEBIT &&
        w.wallet.walletType.id !== WalletType.PAYMENT_AGENT
    )
  }
  return walletTransactions.find(
    (transactionWalletItem) =>
      transactionWalletItem.wallet.walletType.id !== WalletType.PAYMENT_AGENT
  )
}

export function getClientWalletForPaymentAgent(
  walletTransactions: WalletTransaction[],
  type?: 'Credit' | 'Debit'
): WalletTransaction | undefined {
  if (type === 'Credit') {
    return (walletTransactions || []).find(
      (w) =>
        w.directionType.id === WalletDirectionTypeId.CREDIT &&
        w.wallet.walletType.id === WalletType.PAYMENT_AGENT
    )
  }

  if (type === 'Debit') {
    return (walletTransactions || []).find(
      (w) =>
        w.directionType.id === WalletDirectionTypeId.DEBIT &&
        w.wallet.walletType.id === WalletType.PAYMENT_AGENT
    )
  }
  return walletTransactions.find(
    (transactionWalletItem) =>
      transactionWalletItem.wallet.walletType.id === WalletType.PAYMENT_AGENT
  )
}

export function getCreditWalletByDirectionType(
  walletTransactions: WalletTransaction[],
  type?: number
): WalletTransaction {
  const transactionWallet = walletTransactions.find(
    (transactionWalletItem) => transactionWalletItem.directionType.id === type
  )

  return transactionWallet ? transactionWallet : walletTransactions[0]
}

export function getTradingAccount(tradingAccounts: TradingAccount[]): TradingAccount {
  return tradingAccounts[0]
}
